export default "<div>\r\n    <i style=\"color:red\" class=\"fas fa-times-circle fa-3x\"></i>\r\n    <h3 class=\"mt-2\">Payment Process Failed!</h3>\r\n</div>"